<template>
  <div class="main" v-loading="loading">
    <div>
      <div class="conent_title">{{ isPoster ? "全职企业微信海报" : "零工企业微信海报" }}</div>
      <el-button class="isPosterswitch" @click="Posterswitch" type="primary">{{
        isPoster ? "零工企业微信海报" : "全职企业微信海报"
      }}</el-button>
    </div>

    <div class="img_box">
      <div v-for="(item, index) in imageList" :key="index" class="img_item">
        <img class="qr_poster" :src="item.file_id" alt />
        <el-button
          class="delete_btn"
          type="warning"
          @click="deleteItem(item.id)"
          >删除</el-button
        >
      </div>
    </div>

    <el-form class="form-wrapper padding" ref="addForm" label-width="110px">
      <el-form-item label="活动图片：" prop="photo">
        <el-upload
          :action="url_Api + '/hr24_user/v1/upload_file/'"
          multiple
          accept="image/png, image/jpeg"
          list-type="picture-card"
          :on-progress="uploadProgress"
          :on-remove="handleRemove"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          :show-file-list="true"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="addEnsure">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { require, url_Api } from "@/utils/http_request.js";
export default {
  data() {
    return {
      loading: true,
      uploadComplete: true, // 图片上传完成状态
      addList: [],
      imageList: [],

      isPoster: true,

      show_data: "qr_poster",
    };
  },

  created() {
    this.url_Api = url_Api;
    this.list();
  },

  methods: {
    // 零工职工切换
    Posterswitch() {
      this.isPoster
        ? (this.show_data = "odd_qr_poster")
        : (this.show_data = "qr_poster");
      this.isPoster = !this.isPoster;
      this.list();
    },
    //
    list() {
      this.loading = true;
      let obj = {
        //   token: this.$cookies.get("token")
        show_data: this.show_data,
      };
      require("post", "/hr24_user/v1/share_list/", obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.imageList = res.data.poster_list;
          console.log(this.imageList);
        } else {
        }
        this.loading = false;
      });
    },
    deleteItem(e) {
      let that = this;
      let obj = {
        token: this.$cookies.get("token"),
        poster_id: e,
      };
      require("post", "/hr24_user/v1/update_share/", obj).then((res) => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success",
          });

          this.list();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    uploadProgress(event, file, fileList) {
      this.uploadComplete = false;
    },
    // 上传图片成功
    uploadSuccess(res, file, fileList) {
      this.uploadComplete = true;
      console.log(res, file, fileList);
      if (!res.code) {
        let addList = this.addList;
        addList.push(res.data.file_data.file_id);
      }
      console.log(this.addList);
    },

    // 上传图片出错
    uploadError(err, file, fileList) {
      this.$message.error("上传出错");
    },
    // 移除图片
    handleRemove(file, fileList) {
      let addList = this.addList;
      if (!file.response.code) {
        let deleteimage = file.response.data.file_data.file_id;
        addList.map((item, index) => {
          if (deleteimage == item) {
            addList.splice(index, 1);
          }
        });
      }
    },

    // 确认添加
    addEnsure() {
      let obj = {
        token: this.$cookies.get("token"),
        file_id_list: this.addList,
        file_type: this.show_data,
      };
      require("post", "/hr24_user/v1/add_poster/", obj).then((res) => {
        if (!res.code) {
          console.log(res);
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.list();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.img_box {
  height: 100%;
  width: 100%;
  min-width: 1180px;
  display: flex;
  flex-wrap: wrap;
}

.delete_btn {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.img_item {
  margin: 10px;
  width: 9%;
  min-height: 200px;
  background: beige;
  display: flex;
  flex-direction: column;
  position: relative;
}
.qr_poster {
  width: 100%;
}

.conent_title {
  float: left;
  font-size: 24px;
  color: #999;
}
.isPosterswitch {
  margin-right: 80x;
  margin-bottom: 20px;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/user_management/enterprise_photo_upload.vue